'use strict';

export class Molecule {
	constructor(component_key) {
		this.id = component_key;
		this.component = yalwa.v.components[component_key];
		this.$root = jQuery(`.js-${this.id}`);
	}
}
